import * as MainHomeTypes from "./types";

export const add = mainHome => ({
    type: MainHomeTypes.ADD_MAIN_HOME,
    payload: { value: mainHome }
});

export const remove = {
    type: MainHomeTypes.REMOVE_MAIN_HOME
}